export const visualizationPagesPathConstants = {
  listing: '/visualizationPages/list',
  save: '/visualizationPages/save',
  delete: '/visualizationPages/delete',
  sidebarItems: 'visualizationPages/listOfEquipments',
  getLayout: '/visualization/getLayout',
  fetchQuestions: '/visualization/equipmentQuestions',
  submitAnswers: '/visualization/submitAnswers',
  entityName: '/visualization/entityName',
  realTimeScada: 'visualization/realTimeScada',
  listOfPagesVisulaization: '/visualizationPages/list'
}